import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Argon from './plugins/argon-kit'
import axios from 'axios'
import VueAxios from 'vue-axios'
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
import 'vue-airbnb-style-datepicker/dist/styles.css'
import { VueMasonryPlugin } from 'vue-masonry'
import './plugins/fontawesome-library'
import VTooltip from 'v-tooltip'
import VueApexCharts from 'vue-apexcharts'

const datepickerOptions = {}

Vue.use(VueAxios, axios)
Vue.use(AirbnbStyleDatepicker, datepickerOptions)
Vue.config.productionTip = false
Vue.use(Argon)
Vue.use(VueApexCharts)
Vue.use(VTooltip)
Vue.use(VueMasonryPlugin)
Vue.component('apexchart', VueApexCharts)

const vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

global.vm = vm
